import { render, staticRenderFns } from "./POSActions.vue?vue&type=template&id=376e30cb&scoped=true"
import script from "./POSActions.vue?vue&type=script&lang=js"
export * from "./POSActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376e30cb",
  null
  
)

export default component.exports